import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, getFormValues } from 'redux-form'
import { Button, Confirm } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validations, validateCase as vCase } from 'core/validate'
import { AddDummyUserContainer } from './styled'
import { 
  getCompanies,
} from 'ducks/options'
import { 
  adminUpdateNotGRBase,
} from 'ducks/system'

const UpdateLivNo = (props) => {
  const { 
    valueForm,
    companies
  } = props
  const [showConfirm, setShowConfirm] = React.useState(false)

  React.useEffect(()=>{
    props.getCompanies()
  },[])

  const confirmSubmit = () =>{
    setShowConfirm(false)
    props.adminUpdateNotGRBase(valueForm)
  }

  return (
    <AddDummyUserContainer>
      <Confirm
        open={showConfirm}
        onCancel={()=>setShowConfirm(false)}
        onConfirm={()=>confirmSubmit()}
      />
      <form onSubmit={props.handleSubmit(()=>setShowConfirm(true))}>
        <div className='rowFields'>
          <Field 
            name='companyCode' 
            label='Company' 
            type={type.select}
            component={FieldInput}
            loading={companies.loading}
            options={companies.data}
            require/>
          <Field 
            name='year' 
            label='Year' 
            type={type.number}
            component={FieldInput} 
            placeholder='ปี ค.ศ.'
            decimalScale={0}
            thousandSeparator={false}
            allowNegative={false}
            formatValue="####"
            textAlignLeft
            require />
        </div>
        <div className='rowFields'>
          <Field 
            name='oldMaterialDocNo' 
            label='Old Material Doc No.' 
            type={type.text}
            component={FieldInput} 
            require />
          <Field 
            name='oldLivNo' 
            label='Old LIV No.' 
            type={type.text}
            component={FieldInput}
            require />
        </div>
        <div className='rowFields'>
          <Field 
            name='newLivNo' 
            label='New LIV No.' 
            type={type.text}
            component={FieldInput} 
            className='halfRow'
            require/>
        </div>
        <div className='btnContainer'>
          <Button
            content='Save'
            color='green'
            icon='save'
            labelPosition='right'
            style={{ marginRight: '5px' }}
          />
        </div>
      </form>
    </AddDummyUserContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    companies: state.options.companies,
    valueForm: getFormValues('UpdateLivNoForm')(state) || {},
  })
}

const mapDispatchToProps = {
  getCompanies,
  adminUpdateNotGRBase
}

const validate = (values) => {
  let errors = {}
  validations(values, 'companyCode', [vCase.require], errors)
  validations(values, 'year', [vCase.require], errors)
  validations(values, 'oldMaterialDocNo', [vCase.require], errors)
  validations(values, 'oldLivNo', [vCase.require], errors)
  validations(values, 'newLivNo', [vCase.require], errors)

  return errors
}

const UpdateLivNoForm = reduxForm({
  form: 'UpdateLivNoForm',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(UpdateLivNo)

export default connect(mapStateToProps, mapDispatchToProps)(UpdateLivNoForm)